import React from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { Container } from '@//components/common';
import { PERSONAL_ACCOUNT_FISH_PRODUCTS_URL, TOP_ANCHOR_URL } from '@/constants/routes';
import useMobile from '@/hooks/use-mobile';
import { TranslationNamespace } from '@/i18n';

import bgDesktop from './assets/bg-desktop.svg';
import { BasketUpIcon, BoxSeamIcon, ChecklistIcon, FishIcon } from './assets/icons';

import cls from './StartSale.module.scss';

const list: { icon: JSX.Element; title: string; subtitle: string }[] = [
	{
		icon: <ChecklistIcon className={cls.icon} />,
		title: 'main-landing.start-sale.registration',
		subtitle: 'main-landing.start-sale.get-access-to-your-account',
	},
	{
		icon: <BoxSeamIcon className={cls.icon} />,
		title: 'main-landing.start-sale.placement-at-the-warehouse',
		subtitle: 'main-landing.start-sale.place-fish-at-any-fish-warehouse-in-russia-for-storage',
	},
	{
		icon: <FishIcon className={cls.icon} />,
		title: 'main-landing.start-sale.sales-offering',
		subtitle: 'main-landing.start-sale.offer-the-desired-volume-for-sale',
	},
	{
		icon: <BasketUpIcon className={cls.icon} />,
		title: 'main-landing.start-sale.get-orders',
		subtitle:
			'main-landing.start-sale.choose-the-best-offer-in-terms-of-price-and-volume-conduct-the-deal-dire',
	},
];

export default function StartSale() {
	const { isMobile } = useMobile();
	const t = useTranslation(TranslationNamespace.Marketing).t;

	return (
		<section className={cls.section}>
			<Container className={cls.mainContainer}>
				<h2 className={cls.title}>
					{t('main-landing.start-sale.begin-selling-fish-in-4-simple-steps')}
				</h2>
				<p className={cls.subtitle}>
					{t(
						'main-landing.start-sale.receive-orders-from-customers-and-sell-fish-produce-at-the-best-terms-an',
					)}
				</p>
				<Button size="large" type="primary" href={TOP_ANCHOR_URL} className={cls.more}>
					{t('main-landing.start-sale.find-out-more')}
				</Button>
			</Container>

			<div
				className={cls.background}
				style={{ backgroundImage: !isMobile && `url(${bgDesktop.src})` }}
			>
				<Container>
					<ul className={cls.list}>
						{list.map((item, index) => (
							<li key={index} className={cls.item}>
								<div className={cls.iconContainer}>{item.icon}</div>
								<p className={cls.itemTitle}>{t(item.title)}</p>
								<p className={cls.itemSubtitle}>{t(item.subtitle)}</p>
							</li>
						))}
					</ul>

					<div className={cls.actions}>
						<Button
							size="large"
							type="primary"
							className={cls.action}
							href={PERSONAL_ACCOUNT_FISH_PRODUCTS_URL}
						>
							{t('main-landing.start-sale.sell-fish')}
						</Button>
					</div>
				</Container>
			</div>
		</section>
	);
}
